module.exports = __webpack_public_path__ + "static/media/temperature-high.ce59b899.svg";